import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import { loading } from '@/shared/utils/UIHelper'
export default {
  props: ['data', 'dataCol', 'i', 'id'],
  name: 'Tablepriceacording',
  data () {
    return {
      changeAngel: false,
      tipo: null
    }
  },
  mounted () {
    this.GetTipoEmpreendimento()
  },
  methods: {
    GetTipoEmpreendimento () {
      loading.push()
      EnterpriseRepository.GetTipoEmpreedimento(this.id)
        .then(Response => {
          this.tipo = Response.data[0].tipo
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/tablepriceacording/tablepriceacording.js